import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aK3FG"), parcelRequire.load("9f8mp"), parcelRequire.load("bWofC")]).then(() => {
  return Promise.all([waitForCSS("https://reactspectrum.blob.core.windows.net/reactspectrum/c97669a3d5e8db7c781dd1b9c7b4af7da7237e13/s2-docs/error.1bd6f1d3.css")]);
}).then(() => {
let originalModule = parcelRequire("lVVdJ");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aK3FG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("bWofC")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
